import { MonitoringFilters } from 'src/features/monitoringDashboardAlpha/hooks/useMonitoringFilters'

// 検証用機能のため共有の queryKeyPrefix には登録せず、ローカルで完結させる
// (削除時にこのディレクトリごと消せるようにするため)
const prefix = ['ui:monitoringDashboard'] as const

export const queryKeys = {
  dashboardReportSummaries: (filters: MonitoringFilters) => [
    ...prefix,
    'dashboardReportSummaries',
    filters,
  ],
}
